'use client'

import { useEffect } from 'react'

function isIOSSafari() {
  if (typeof window === 'undefined') return false
  const ua = window.navigator.userAgent
  const isIOSDevice = /iP(hone|od|ad)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  const isWebKit = /WebKit\//.test(ua)
  const isNotOtherIOSBrowsers = !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua)
  return isIOSDevice && isWebKit && isNotOtherIOSBrowsers
}

const IOSSafariHeaderFix = () => {
  useEffect(() => {
    if (!isIOSSafari()) return

    const root = document.documentElement
    const body = document.body
    root.classList.add('ios-safari')

    const updateHeaderHeight = () => {
      const header = document.querySelector('.site-header')
      const height = header ? header.offsetHeight : 0
      root.style.setProperty('--header-height', `${height}px`)
      body.style.paddingTop = `${height}px`
    }

    // Initial measure and on next frame to catch font loading
    updateHeaderHeight()
    const raf = requestAnimationFrame(updateHeaderHeight)

    const onResize = () => updateHeaderHeight()
    const onOrientation = () => updateHeaderHeight()

    window.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', onOrientation)

    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener('resize', onResize)
      window.removeEventListener('orientationchange', onOrientation)
      // Keep class and padding while navigating client-side; no cleanup needed here
    }
  }, [])

  return null
}

export default IOSSafariHeaderFix
